import { useNavigate, useLocation } from 'react-router-dom'
import { createValidationViewModel, createWebPlatformServices } from '@restaurant/viewmodels'

/**
 * Web-specific ValidationViewModel adapter
 * Uses web platform services for validation preferences storage
 */
export const useValidationViewModel = () => {
  const navigate = useNavigate()
  const location = useLocation()
  
  // Create web platform services
  const platformServices = createWebPlatformServices(navigate, location)
  
  // Create and return the platform-agnostic ValidationViewModel
  const ValidationViewModelHook = createValidationViewModel(platformServices)
  return ValidationViewModelHook()
}

// Re-export types for convenience
export type { 
  ValidationViewModel, 
  ValidationViewModelState, 
  ValidationViewModelActions 
} from '@restaurant/viewmodels'